import AEMFooter from "@components/Footer/AEMFooter";
import PopularSearches from "@components/PopularSearches";
import LogoAndText from "@components/atoms/EthinosHomeLeft/LogoAndText";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const footerContactData = [
  {
    imgUrl: "/ethinos-home-page/svgs/footer/website-globe-logo.svg",
    text: "www.nivabupa.com",
    h: 18,
    w: 16,
  },
  {
    imgUrl: "/ethinos-home-page/svgs/footer/fax-logo.svg",
    text: "+91 11 41743397",
    h: 18,
    w: 16,
  },
  {
    imgUrl: "/ethinos-home-page/svgs/footer/phone-logo.svg",
    text: "1860-500-8888",
    h: 18,
    w: 16,
  },
  {
    imgUrl: "/ethinos-home-page/svgs/footer/map-logo.svg",
    text: "3rd Floor, Capital Cyberscape, Sector 59, Gurgaon",
    h: 18,
    w: 16,
  },
];

const socialMediaLinks = [
  {
    imageUrl: "/ethinos-home-page/svgs/socials/fb-logo.svg",
    linkUrl: "https://www.facebook.com/NivaBupa/",
    name: "facebook",
  },
  {
    imageUrl: "/ethinos-home-page/svgs/socials/twitter-logo.svg",
    linkUrl: "https://twitter.com/niva_bupa",
    name: "twitter",
  },
  {
    imageUrl: "/ethinos-home-page/svgs/socials/youtube-logo.svg",
    linkUrl: "https://www.youtube.com/@NivaBupa",
    name: "youtube",
  },
  {
    imageUrl: "/ethinos-home-page/svgs/socials/linkedin-logo.svg",
    linkUrl: "https://www.linkedin.com/company/niva-bupa?originalSubdomain=in",
    name: "linkedin",
  },
  {
    imageUrl: "/ethinos-home-page/svgs/socials/instagram-logo.svg",
    linkUrl: "http://www.instagram.com/nivabupaofficial/",
    name: "instagram",
  },
];

function FooterV1({ homePageData, popularSearches = true, dynamicFooterData }) {
  return (
    <div id="footer-container" className="flex flex-col gap-8 pt-2 px-[44px] mx-auto max-w-[1280px] w-full">
      {popularSearches && <PopularSearches newDesignConfig={true} />}
      <AEMFooter newDesignConfig={true} />
      <div id="footer-contact" className="flex flex-col items-center gap-6 pb-4 border-b border-gray-500">
        <img
          id="footer-logo"
          src="/ethinos-home-page/images/footer-logo.svg"
          height={60}
          width={117}
          loading="lazy"
          alt="footer logo"
        />
        <div id="footer-contact-details" className="flex flex-wrap items-center justify-center gap-10 md:flex-row">
          {(footerContactData ?? []).map((item, index) => {
            return <LogoAndText key={index} {...item} />;
          })}
        </div>
      </div>

      {dynamicFooterData ? (
        <div id="dynamic-footer" dangerouslySetInnerHTML={{ __html: dynamicFooterData }} />
      ) : (
        <div id="static-footer">
          <ul className="flex flex-col items-start gap-8 px-0 text-sm text-left text-black">
            {homePageData?.footerDisclaimers?.map((disclaimer, index) => (
              <li key={index} id={`footer-disclaimer-${index}`}>
                {disclaimer.superscript && (
                  <span className="align-top text-xs mt-[-0.25em]">
                    {disclaimer.superscript}
                  </span>
                )}
                {disclaimer.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div id="social-media-links" className="relative flex flex-row items-center justify-center gap-6 pb-24 border-b border-gray-500">
        <div className="flex flex-row items-center justify-center gap-4">
          {socialMediaLinks.map((obj, index) => {
            return (
              <Link prefetch={false} href={obj.linkUrl} key={index} >
                <img
                  key={index}
                  alt={`${obj.name} icon`}
                  src={obj.imageUrl}
                  height={25}
                  width={25}
                  loading="lazy"
                  className="w-7 h-7"
                  id={`social-link-${obj.name}`}
                />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FooterV1;
